(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-nb-two-shade]').forEach((box) => {
      if (box.dataset.nbInitialized === 'true') return;
      box.dataset.nbInitialized = 'true';
      const one = box.querySelector('[data-nb-shade-one]');
      const two = box.querySelector('[data-nb-shade-two]');
      const button = box.querySelector('[data-nb-add-pair]');
      const error = box.querySelector('[data-nb-shade-error]');
      const status = box.querySelector('[data-nb-shade-status]');
      if (!one || !two || !button) return;

      const selected = (group) => group.querySelector('[data-nb-shade-option][aria-pressed="true"]');
      const setSelection = (group, choice) => {
        group.querySelectorAll('[data-nb-shade-option]').forEach((swatch) => {
          swatch.setAttribute('aria-pressed', swatch === choice ? 'true' : 'false');
        });
        const selectedLabel = group.querySelector('[data-nb-selected-label] strong');
        if (selectedLabel) selectedLabel.textContent = choice.dataset.shadeName || 'Choose a shade';
      };
      const scrollToMainImage = () => {
        const gallery = document.querySelector('media-gallery');
        if (!gallery) return;
        const top = gallery.getBoundingClientRect().top + window.scrollY - 16;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      };
      const updateMainImage = (swatch) => {
        const imageUrl = swatch.dataset.image;
        const mediaId = swatch.dataset.mediaId;
        const gallery = document.querySelector('media-gallery');
        let switchedWithNativeGallery = false;

        if (mediaId && gallery) {
          const slide = gallery.querySelector('#Slide-' + mediaId)
            || gallery.querySelector('[data-media-id="' + mediaId + '"]');
          if (slide && typeof gallery.setActiveMedia === 'function') {
            gallery.setActiveMedia(mediaId, false);
            switchedWithNativeGallery = true;
          } else {
            const thumbnail = gallery.querySelector('[data-target="' + mediaId + '"] button');
            if (thumbnail) {
              thumbnail.click();
              switchedWithNativeGallery = true;
            }
          }
        }

        window.setTimeout(() => {
          const currentSlide = gallery && mediaId ? gallery.querySelector('[data-media-id="' + mediaId + '"]') : null;
          const currentImage = currentSlide && currentSlide.querySelector('img');
          const currentSrc = currentImage ? (currentImage.currentSrc || currentImage.src) : '';
          const expectedFile = (imageUrl || '').split('/').pop().split('?')[0].replace(/_(\d+x\d*)?\./, '.');
          const visibleFile = currentSrc.split('/').pop().split('?')[0].replace(/_(\d+x\d*)?\./, '.');
          if (switchedWithNativeGallery && currentImage && (currentSrc === imageUrl || (expectedFile && visibleFile === expectedFile))) {
            scrollToMainImage();
            return;
          }
          const mainImage = gallery?.querySelector('.product__media-list .product__media-item.is-active img')
            || gallery?.querySelector('.product__media-list [data-media-id] img')
            || gallery?.querySelector('.product__media img')
            || document.querySelector('.product__media-wrapper img');
          if (mainImage && imageUrl) {
            const picture = mainImage.closest('picture');
            if (picture) picture.querySelectorAll('source').forEach((source) => {
              source.removeAttribute('srcset');
              source.removeAttribute('sizes');
            });
            mainImage.src = imageUrl;
            mainImage.removeAttribute('srcset');
            mainImage.setAttribute('srcset', '');
            mainImage.alt = swatch.dataset.shadeName + ' lipstick shade';
            mainImage.loading = 'eager';
          }
          scrollToMainImage();
        }, switchedWithNativeGallery ? 180 : 0);
      };

      [one, two].forEach((group) => {
        group.addEventListener('click', (event) => {
          const swatch = event.target.closest('[data-nb-shade-option]');
          if (!swatch || !group.contains(swatch)) return;
          setSelection(group, swatch);
          error.hidden = true;
          const first = selected(one);
          const second = selected(two);
          status.textContent = first && second
            ? 'Both lipstick shades selected. Your Buy 1 Get 1 Free offer is ready.'
            : '1 of 2 lipstick shades selected. Choose one more shade.';
          status.hidden = false;
          updateMainImage(swatch);
        });
      });

      button.addEventListener('click', async () => {
        error.hidden = true;
        status.hidden = true;
        const shadeOne = selected(one);
        const shadeTwo = selected(two);
        if (!shadeOne || !shadeTwo) {
          error.textContent = 'Please select one shade in each section to unlock Buy 1 Get 1 Free.';
          error.hidden = false;
          return;
        }
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding both shades…';
        const shadeOneName = shadeOne.dataset.shadeName;
        const shadeTwoName = shadeTwo.dataset.shadeName;
        const pairKey = 'NB-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [
              { id: Number(shadeOne.dataset.variantId), quantity: 1, properties: { 'Shade selection': '1 of 2', 'Selected shade': shadeOneName, 'Shade pair': pairKey } },
              { id: Number(shadeTwo.dataset.variantId), quantity: 1, properties: { 'Shade selection': '2 of 2', 'Selected shade': shadeTwoName, 'Shade pair': pairKey } }
            ] })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Could not add both shades.');
          button.textContent = 'Added — opening cart…';
          window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
        } catch (e) {
          error.textContent = e.message || 'Something went wrong. Please try again.';
          error.hidden = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = 'Add 2 shades to cart';
        }
      });

      const sticky = box.querySelector('[data-nb-sticky-pair]');
      const stickyButton = sticky?.querySelector('[data-nb-sticky-add]');
      const stickyShades = sticky?.querySelector('[data-nb-sticky-shades]');
      if (sticky && stickyButton) {
        // Move the fixed bar to body so product/gallery stacking contexts cannot clip it.
        document.body.appendChild(sticky);
        const syncSticky = () => {
          const first = selected(one), second = selected(two);
          const ready = Boolean(first && second);
          stickyButton.disabled = !ready || button.disabled;
          if (stickyShades) stickyShades.textContent = ready
            ? (first.dataset.shadeName || 'Shade 1') + ' + ' + (second.dataset.shadeName || 'Shade 2')
            : (first ? (first.dataset.shadeName || '1 shade selected') + ' · Choose 1 more' : 'Select 2 shades to continue');
          updateStickyVisibility();
        };
        const updateStickyVisibility = () => {
          const rect = box.getBoundingClientRect();
          const ready = Boolean(selected(one) && selected(two));
          const selectorIsAbove = rect.bottom <= 8;
          const show = ready && selectorIsAbove;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        };
        stickyButton.addEventListener('click', () => {
          syncSticky();
          if (!stickyButton.disabled) button.click();
        });
        [one, two].forEach((group) => group.addEventListener('click', syncSticky));
        new MutationObserver(syncSticky).observe(button, { attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
        window.addEventListener('scroll', updateStickyVisibility, { passive: true });
        window.addEventListener('resize', updateStickyVisibility);
        syncSticky();
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  // Generic sticky Add to Cart for non-BOGO product pages.
  const initGenericSticky = (root = document) => {
    const productRoot = root.querySelector ? root.querySelector('product-info') : null;
    const roots = productRoot ? [productRoot] : (root.matches && root.matches('product-info') ? [root] : Array.from(document.querySelectorAll('product-info')));
    roots.forEach((productInfo) => {
      if (productInfo.querySelector('[data-nb-two-shade]') || productInfo.dataset.nbGenericStickyReady === 'true') return;
      const form = productInfo.querySelector('product-form form[action*="/cart/add"]');
      const originalButton = form?.querySelector('[type="submit"]');
      if (!form || !originalButton) return;
      productInfo.dataset.nbGenericStickyReady = 'true';
      const style = document.createElement('style');
      style.textContent = '.nb-generic-sticky-atc{position:fixed;z-index:49;left:0;right:0;bottom:0;padding:10px 14px calc(10px + env(safe-area-inset-bottom));background:rgba(255,255,255,.97);border-top:1px solid #eadde1;box-shadow:0 -5px 22px rgba(48,35,43,.12);backdrop-filter:blur(10px);transform:translateY(110%);opacity:0;visibility:hidden;transition:transform .22s ease,opacity .22s ease,visibility .22s ease}.nb-generic-sticky-atc.is-visible{transform:translateY(0);opacity:1;visibility:visible}.nb-generic-sticky-atc__inner{display:flex;align-items:center;gap:12px;max-width:1180px;margin:0 auto}.nb-generic-sticky-atc__info{flex:1;min-width:0;color:#30232b;font-size:12px;line-height:1.35}.nb-generic-sticky-atc__info strong{display:block;font-weight:700;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.nb-generic-sticky-atc__info span{display:block;color:#786872;font-size:11px;margin-top:2px}.nb-generic-sticky-atc__button{flex:0 0 auto;min-width:155px;min-height:46px;padding:0 18px;border:0;border-radius:4px;background:#4b2638;color:#fff;font-size:12px;font-weight:700;cursor:pointer}.nb-generic-sticky-atc__button:disabled{opacity:.5;cursor:not-allowed}@media(min-width:750px){.nb-generic-sticky-atc{padding:12px 24px calc(12px + env(safe-area-inset-bottom))}.nb-generic-sticky-atc__button{min-width:230px;min-height:50px;font-size:13px}}@media(max-width:380px){.nb-generic-sticky-atc__inner{gap:8px}.nb-generic-sticky-atc__button{min-width:130px;padding:0 10px;font-size:11px}}@media(prefers-reduced-motion:reduce){.nb-generic-sticky-atc{transition:none}}';
      document.head.appendChild(style);
      const bar = document.createElement('div');
      bar.className = 'nb-generic-sticky-atc';
      bar.setAttribute('aria-hidden','true');
      const title = document.querySelector('.product__title h1')?.textContent?.trim() || 'This product';
      bar.innerHTML = '<div class="nb-generic-sticky-atc__inner"><div class="nb-generic-sticky-atc__info"><strong></strong><span>Ready to add</span></div><button type="button" class="nb-generic-sticky-atc__button">Add to cart</button></div>';
      bar.querySelector('strong').textContent = title;
      document.body.appendChild(bar);
      const stickyButton = bar.querySelector('button');
      const update = () => {
        const rect = originalButton.getBoundingClientRect();
        const show = rect.bottom < 0 && !originalButton.disabled;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyButton.disabled = originalButton.disabled;
        stickyButton.textContent = originalButton.disabled ? 'Sold out' : 'Add to cart';
      };
      stickyButton.addEventListener('click', () => { if (!stickyButton.disabled) originalButton.click(); });
      new MutationObserver(update).observe(originalButton,{attributes:true,attributeFilter:['disabled','aria-busy']});
      form.addEventListener('change',() => window.setTimeout(update,80));
      window.addEventListener('scroll',update,{passive:true});
      window.addEventListener('resize',update);
      update();
    });
  };
  const runGenericSticky = () => initGenericSticky(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',runGenericSticky);
  else runGenericSticky();
  document.addEventListener('shopify:section:load',event => initGenericSticky(event.target));

})();